import Vue from 'vue'
import PreviewImage from './component/preview-wrapper/preview-image.vue'
import PreviewFile from './component/preview-wrapper/preview-file.vue'
import { KYE_PREVIEW_VERSION, NO_PREVIEWS_LIST, IMG_KEYS } from './component/preview-wrapper/constant'

function isDOM(item) {
  return typeof HTMLElement === 'function'
    ? item instanceof HTMLElement
    : item && typeof item === 'object' && item.nodeType === 1 && typeof item.nodeName === 'string'
}

/**
 *
 * @desc 根据url生成 bizCodeId fileId 查看url是否存在 download， 存在取download后面3个用 / 隔开的字符
 * @param {*} url
 * @return {*}
 */
function createBizCodeIdFileIdInUrl(url) {
  if (!url || typeof url !== 'string') {
    return {}
  }
  const [downLink] = url.split('?')
  const splitDownLink = downLink.split('/')
  const downloadIndex = splitDownLink.findIndex(str => str === 'download')
  const data = downloadIndex > -1 ? splitDownLink.slice(downloadIndex + 1, splitDownLink.length) : []
  const keys = ['bizCode', 'bizId', 'id']
  const result = data.reduce((pre, val, index) => {
    const key = keys[index]
    pre[key] = val
    return pre
  }, {})
  return result
}

/**
 *
 * @desc 合并组件的配置
 * @param {*} options
 * @return {*}
 */

function assignOptions(options) {
  const {
    url,
    list,
    imgTypeList = [],
    pdfTypeList = [],
    extendName,
    pdfParams,
    previewErrorSlot,
    isPrewFileToPdf
  } = options || {}
  let result = {}
  let imgSrc = null
  let imglist = []
  // 单图片
  if (url) {
    result = createBizCodeIdFileIdInUrl(url)
    imglist = [
      {
        url,
        extendName,
        pdfParams,
        previewErrorSlot,
        ...result
      }
    ]
  }
  // 如果存在list。则过滤处理图片。
  if (list) {
    const imgResult = filterImgSrc(list, [...imgTypeList, ...pdfTypeList], isPrewFileToPdf)
    imgSrc = imgResult.imgSrc
    imglist = imgResult.imglist
  }
  let index = imgSrc ? imgSrc.findIndex(src => src === url) : -1
  if (options.index) {
    index = options.index
  }
  return {
    ...options,
    ...result,
    url: imgSrc || url,
    index,
    imglist, // 图片列表的元数据
    dialogOption: Object.assign(
      {},
      {
        title: '图片查看',
        width: '900px'
      },
      options.dialogOption
    )
  }
}

function isImage(type, userImgTypeList = []) {
  try {
    const t = String(type).toLowerCase()
    return (
      IMG_KEYS.indexOf(t) > -1 ||
      (Array.isArray(userImgTypeList) && userImgTypeList.length && userImgTypeList.indexOf(t) > -1)
    )
  } catch (error) {
    return false
  }
}

function filterImgSrc(list = [], imgTypeList, isPrewFileToPdf) {
  if (!list.length) {
    return
  }
  const data = isPrewFileToPdf ? list : list.filter(file => isImage(file.extendName, imgTypeList))
  return data.reduce(
    (obj, file) => {
      obj.imgSrc.push(file.url)
      obj.imglist.push({
        ...file,
        ...createBizCodeIdFileIdInUrl(file.url)
      })
      return obj
    },
    {
      imgSrc: [],
      imglist: []
    }
  )
}

function computedPreviewType(options) {
  const [row] = options.list || []
  const { url: firstUrl, extendName: firstExtendName } = row || {}
  const { extendName = firstExtendName, list = [], url = firstUrl } = options
  let type = extendName || ''
  const item = list.find(ele => ele.url === url)
  if (item) {
    type = item.extendName
  }
  return String(type).toLowerCase()
}

export const canTransformPdfTypeList = [
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'pdf',
  'txt',
  'ofd',
  'mp3',
  'mov',
  'mp4',
  'wav'
]

export default function openPreview(options) {
  let { version = '', appendTo = null, imgTypeList = [], isPrewFileToPdf = true, mustPreivewType = [] } = options || {}
  options.pdfTypeList = [
    ...new Set([...canTransformPdfTypeList, ...(options.pdfTypeList || []), ...(mustPreivewType || [])])
  ]
  const pdfTypeList = options.pdfTypeList
  const type = computedPreviewType(options)
  // 预览的组件实例根据类型区分。文件类型使用新页签打开，反之使用kye-image组件加弹窗
  let PreviewItemConstructor = Vue.extend(PreviewImage)
  if (isPrewFileToPdf !== true) {
    if (NO_PREVIEWS_LIST.indexOf(type) > -1) {
      Vue.prototype.$message.warning('该文件类型不支持预览')
      return
    }
    // 预判的类型区分，pdf展示的也可以认为是图片
    const previewImg = isImage(type, [...imgTypeList, ...(isPrewFileToPdf ? pdfTypeList : [])])
    // 如果不是图片预览。那么就是文件预览。检测是否缺少必须的参数。
    if (!previewImg) {
      if (!(options.list && options.list.length) && !options.url && !options.bizCode && !options.bizId) {
        console.error('File preview missing required parameters')
        return
      }
      PreviewItemConstructor = Vue.extend(PreviewFile)
    }
  }

  return new Promise((resolve, reject) => {
    let instance = null
    instance = new PreviewItemConstructor({
      el: document.createElement('div')
    })
    if (appendTo) {
      if (typeof appendTo === 'string') {
        appendTo = document.querySelector(appendTo)
      } else if (appendTo.$el) {
        appendTo = appendTo.$el
      }
    }
    if (appendTo && !isDOM(appendTo)) {
      reject(new Error('appendTo的类型应该为DOM或者css选择器!!!'))
      return
    }
    const parent = appendTo || document.querySelector('.main-panel div')
    // 默认追加到body下
    // 如果已经存在就不再创建了
    const className = KYE_PREVIEW_VERSION + version
    const isExitPreviewDom = document.querySelector('.' + className)
    !isExitPreviewDom && parent && parent.appendChild(instance.$el)
    const mergeOptions = assignOptions(options)
    // 属性合并
    for (let prop in mergeOptions) {
      if (mergeOptions.hasOwnProperty(prop)) {
        instance[prop] = mergeOptions[prop]
      }
    }
    instance['parent'] = parent
    Vue.nextTick(() => {
      // 打开弹窗
      instance.value = true
    })
    resolve(instance)
  })
}

export { openPreview }



// WEBPACK FOOTER //
// ./src/public/components/kye-preview/preview.js